import PropTypes from 'prop-types';

// Warns that an input / output changed species after the balance was written
// against it. Non-blocking: the equations may well still apply, so the user
// clears each one with "Mark reviewed" once they've checked.

const NOUN = { inputs: 'Input', outputs: 'Output' };

const SpeciesChangeNotice = ({ changes, speciesLabel, rowLabel, onAcknowledge }) => {
  if (!changes.length) return null;
  return (
    <div className="bg-amber-50 border border-amber-200 rounded p-2 text-xs text-amber-800 mb-2">
      <div className="font-medium mb-1">Species changed since the balance was written</div>
      <ul className="space-y-1">
        {changes.map(change => (
          <li key={`${change.kind}-${change.idx}`} className="flex items-start justify-between gap-3">
            <span>
              {NOUN[change.kind]} &quot;{rowLabel(change)}&quot; was <strong>{speciesLabel(change.from)}</strong> and is
              now <strong>{speciesLabel(change.to)}</strong>. Check that its equations and parameters still apply.
            </span>
            <button
              type="button"
              className="shrink-0 text-amber-900 hover:underline"
              onClick={() => onAcknowledge(change)}
            >
              Mark reviewed
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

SpeciesChangeNotice.propTypes = {
  changes: PropTypes.arrayOf(
    PropTypes.shape({
      kind: PropTypes.oneOf(['inputs', 'outputs']).isRequired,
      idx: PropTypes.number.isRequired,
      from: PropTypes.string.isRequired,
      to: PropTypes.string,
    }),
  ).isRequired,
  speciesLabel: PropTypes.func.isRequired,
  rowLabel: PropTypes.func.isRequired,
  onAcknowledge: PropTypes.func.isRequired,
};

export default SpeciesChangeNotice;
